// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubaccountsAnticipations_SyncInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /subaccounts/anticipations/sync/{id}
 *
 * Syncs a single anticipation from upstream provider. No body required —
 * the anticipation id is a URL path parameter.
 */
import { registerContract } from './validate'

export interface SubaccountsAnticipations_SyncInput {}

registerContract('SubaccountsAnticipations_SyncInput', {})
